import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { EmailGateEnum } from '@zaoblako/shared/modules/integration/enums/email.gate.enum';
import type { EnumI18nInterface } from '@zaoblako/shared/common/interfaces/enum.i18n.interface';

/** Localized human-readable string representations of {@link EmailGateEnum} enumeration values */
export const EmailGateEnumI18n: EnumI18nInterface<EmailGateEnum> = {
  [I18nLocalesEnum.RU_RU]: {
    [EmailGateEnum.FRM]: 'ФРМ',
    [EmailGateEnum.MAIN_SMS]: 'MainSMS',
  },
  [I18nLocalesEnum.EN_US]: {
    [EmailGateEnum.FRM]: 'ФРМ',
    [EmailGateEnum.MAIN_SMS]: 'MainSMS',
  },
};
